import React from "react";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// nodejs library that concatenates classes
// import classNames from "classnames";
// @material-ui/core components
// @material-ui/icons
import D1Icon from "@material-ui/icons/Palette";
import D2Icon from "@material-ui/icons/People";
import D3Icon from "@material-ui/icons/AssignmentTurnedIn";
import D4Icon from "@material-ui/icons/ImportantDevices";
import D5Icon from "@material-ui/icons/Favorite";
import D6Icon from "@material-ui/icons/Work";
import D7Icon from "@material-ui/icons/Games";
import withStyles from "@material-ui/core/styles/withStyles";
import domainCircleScoreStyle from "assets/jss/material-kit-pro-react/components/domainCircleScoreStyle.jsx";

import {
  CircularProgressbarWithChildren,
  buildStyles
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";

function DomainCircleScore({ ...props }) {
  const { classes, id, domain, value, showScoreText } = props;
  let iconDomain = null;
  let colorDomain = null;
  const backgroundColor = "yellow";
  let backgroundFlag = false;

  let scoreText = null;
  if (value >= 4) {
    scoreText = 'Capability fully developed';
    backgroundFlag = true;
  } else if (value >= 3) {
    scoreText = 'Capability met, with room for improvement';
  } else if (value >= 2) {
    scoreText = 'Capability emerging';
  } else if (value >= 1) {
    scoreText = 'Capability development required';
  }

  switch (domain) {
    case "D1":
      colorDomain = domainCircleScoreStyle.d1.color;
      iconDomain = <D1Icon style={{ fontSize: "4em", color: colorDomain }} />;
      break;
    case "D2":
      colorDomain = domainCircleScoreStyle.d2.color;
      iconDomain = <D2Icon style={{ fontSize: "4em", color: colorDomain }} />;
      break;
    case "D3":
      colorDomain = domainCircleScoreStyle.d3.color;
      iconDomain = <D3Icon style={{ fontSize: "4em", color: colorDomain }} />;
      break;
    case "D4":
      colorDomain = domainCircleScoreStyle.d4.color;
      iconDomain = <D4Icon style={{ fontSize: "4em", color: colorDomain }} />;
      break;
    case "D5":
      colorDomain = domainCircleScoreStyle.d5.color;
      iconDomain = <D5Icon style={{ fontSize: "4em", color: colorDomain }} />;
      break;
    case "D6":
      colorDomain = domainCircleScoreStyle.d6.color;
      iconDomain = <D6Icon style={{ fontSize: "4em", color: colorDomain }} />;
      break;
    case "D7":
      colorDomain = domainCircleScoreStyle.d7.color;
      iconDomain = <D7Icon style={{ fontSize: "4em", color: colorDomain }} />;
      break;
  }
  return (
    <div className={classes.domainCircleScoreStyle}>
      <CircularProgressbarWithChildren
        maxValue={4}
        minvalue={0}
        value={value}
        background={false}
        // circleRatio={0.5}
        // circleRatio={0.75}
        styles={buildStyles({
          // rotation: 0.75,
          // rotation: 1 / 2 + 1 / 8,
          pathColor: colorDomain,
          backgroundColor: backgroundColor
        })}
      >
        <div style={{ marginTop: -5 }}>{iconDomain}</div>
      </CircularProgressbarWithChildren>
      {showScoreText ? <p>{scoreText}</p> : null}
    </div>
  );
}

DomainCircleScore.defaultProps = {
  iconColor: "gray",
  showScoreText: false
};

DomainCircleScore.propTypes = {
  classes: PropTypes.object.isRequired,
  id: PropTypes.string.isRequired,
  domain: PropTypes.string.isRequired,
  value: PropTypes.number,
  showScoreText: PropTypes.bool
};

export default withStyles(domainCircleScoreStyle)(DomainCircleScore);
